.dropdown-selector {
  background-color: #fff;
  overflow-y: scroll;
  position: absolute;
  border: 1px solid rgb(198, 198, 198);
  font-family: arial, sans-serif;
  z-index: 103;
  font-style: normal;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.dropdown-option-container {
  cursor: pointer;
  display: flex;
  padding: 10px 16px;
  align-items: center;
  list-style-type: none;
}

.overflow-hidden {
  overflow: hidden !important;
}

.is-mobile-viewport.dropdown-selector {
  max-width: 285px !important;
}
